var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayer24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_player24x24",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiple-users-silhouette",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46072",
    "data-name": "Path 46072",
    d: "M10.862,8.922a3.235,3.235,0,0,1,1.522,2.406,2.658,2.658,0,0,0,3.094-.636,2.592,2.592,0,0,0,.26-3.117,2.651,2.651,0,0,0-2.947-1.129,2.617,2.617,0,0,0-1.929,2.478ZM9.133,14.273a2.614,2.614,0,1,0-2.64-2.613,2.627,2.627,0,0,0,2.64,2.613Zm1.12.178H8.013A3.367,3.367,0,0,0,4.633,17.8v2.711l.007.043.189.058a15.529,15.529,0,0,0,4.6.734,9.519,9.519,0,0,0,4.013-.745l.176-.088h.019V17.8a3.366,3.366,0,0,0-3.384-3.346Zm4.368-2.7H12.4A3.205,3.205,0,0,1,11.4,14,3.981,3.981,0,0,1,14.269,17.8v.836a9.179,9.179,0,0,0,3.543-.737l.176-.088H18V15.1a3.367,3.367,0,0,0-3.38-3.347ZM4.5,11.575a2.642,2.642,0,0,0,1.4-.4A3.228,3.228,0,0,1,7.133,9.109c0-.049.007-.1.007-.147A2.64,2.64,0,1,0,4.5,11.575ZM6.871,14a3.208,3.208,0,0,1-1-2.231c-.082-.006-.164-.013-.248-.013H3.38A3.367,3.367,0,0,0,0,15.1v2.712l.007.042.189.059A15.991,15.991,0,0,0,4,18.62V17.8A3.982,3.982,0,0,1,6.871,14Z",
    transform: "translate(0 -6.348)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayer24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_player24x24.3543603e1d66b37b17c14e06a167e721.svg";